import Page from "./Page";
import StoryPanels from "./StoryPanel.ejs";
import FinishedStoryPanels from "./StoryComplete.ejs";
import Events from "../Utils/EventLite";
import {CONFIG} from "../config";

export default class StoryPanel extends Page {
    constructor(name, model) {
        if(name === "Story") {
            super(StoryPanels, model, name);
        } else {
            super(FinishedStoryPanels, model, name);
        }
        this.back = this.element.getElementsByClassName("back")[0];
        this.forward = this.element.getElementsByClassName("forward")[0];
        this.prevScreenButton = this.element.getElementsByClassName("prevScreen")[0];
        this.prevButtonLabel = this.prevScreenButton.getElementsByClassName("label")[0];
        this.nextScreenButton = this.element.getElementsByClassName("nextScreen")[0];
        this.nextButtonLabel = this.nextScreenButton.getElementsByClassName("label")[0];
        this.element.classList.add("fullscreen");
        this.model = model;
        this.panels = null;
    }
    init(resolve, reject) {
        super.init(resolve, reject);
        if(this.panels == null) {
            this.panels = Array.from(this.element.getElementsByClassName("storypanels")[0].childNodes);
            this.panels = this.panels.filter((el)=>{
                return el.nodeName === "LI";
            })
        }
        this.setPanel(0,0);
        this.manageButtons(0);
    }
    manageButtons(index) {
        if(localStorage.getItem("vote"+CONFIG.year)) {
           this.prevButtonLabel.innerHTML = this.model.altPrevLabel;
           this.prevScreenButton.setAttribute("data-action", this.model.altPrev);
           this.nextButtonLabel.innerHTML = this.model.altNextLabel;
           this.nextScreenButton.setAttribute("data-action", this.model.altNext);
        } else {
            this.prevButtonLabel.innerHTML = this.model.prevLabel;
            this.prevScreenButton.setAttribute("data-action", this.model.prev);
            this.nextButtonLabel.innerHTML = this.model.nextLabel;
            this.nextScreenButton.setAttribute("data-action", this.model.next);
        }
        if(index === 0 ) {
            this.prevScreenButton.classList.remove("hide");
            this.back.classList.add("hide");
        } else {
            this.prevScreenButton.classList.add("hide");
            this.back.classList.remove("hide");
        }
        if(index === this.panels.length - 1) {
            this.nextScreenButton.classList.remove("hide");
            this.forward.classList.add("hide"); 
        } else {
            this.nextScreenButton.classList.add("hide");
            this.forward.classList.remove("hide");
        }
    }
    resetPanels() {
        this.panels.forEach((panel)=>{
            panel.classList.remove("selected");
        });
    }
    getCurrentIndex () {
        return this.panels.findIndex((panel)=>{
            return panel.classList.contains("selected");
        })
    }
    setPanel(delta, cIndex = null) {
        var currentIndex = cIndex == null ? this.getCurrentIndex() : cIndex;
        this.resetPanels();
        if(currentIndex <= this.panels.length-1 && currentIndex+delta >= 0) {
            this.panels[currentIndex+delta].classList.add("selected");
        }
        this.manageButtons(currentIndex+delta);
        Events.trigger("Stop", "panel"+currentIndex)
        Events.trigger("Play", "panel"+currentIndex+delta);
    }
    handleButton(e) {
        switch (e.currentTarget.getAttribute("data-action")) {
            case "forward":
            this.setPanel(1);
            return;
            case "back":
            this.setPanel(-1);
            return;
        }

        Events.trigger("goto", e.currentTarget.getAttribute("data-action"))

    }
}


// WEBPACK FOOTER //
// ./src/views/StoryPanel.js